export enum FormatType {
  paragraph = 'paragraph',
  bold = 'bold',
  italic = 'italic',
  underline = 'underline',
  strike = 'strike',
  link = 'link',
  linkInternal = 'linkInternal',
  orderedList = 'orderedList',
  unorderedList = 'unorderedList',
  listItem = 'listItem',
  emoji = 'emoji',
  heading = 'heading',
  heading3 = 'heading3',
  heading4 = 'heading4',
  heading5 = 'heading5',
  heading6 = 'heading6',
  highlight = 'highlight',
  image = 'image',
  blockquote = 'blockquote',
  figure = 'figure',
  figcaption = 'figcaption',
  relatedArticle = 'relatedArticle',
  table = 'table',
  tableCell = 'tableCell',
  tableHeader = 'tableHeader',
  tableRow = 'tableRow',
  tweet = 'tweet',
  assetChart = 'assetChart',
  ad = 'ad',
  htmlCode = 'htmlCode',
  prosAndCons = 'prosAndCons',
  pacContainer = 'pacContainer',
  pros = 'pros',
  cons = 'cons',
  description = 'description',
}
